import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SexService {

  constructor(private _http: HttpClient) { }

  getSex() {
    return this._http.get<any>('api/dictionary/sex/all');
  }
}



// WEBPACK FOOTER //
// ./src/app/common_services/sex.service.ts